import { useCallback, useEffect, useState } from "react";

import type { V3Start } from "../ProgramEditorV3/useV3Navigation";

// The followed card's one selection (#358): the week and session Start runs.
// It follows the computed next slot (a late progress fetch) until the athlete
// picks, on the card's chips or in the open preview's navigation; then the
// pick stays. The preview opens on it and reports back through `pick`.
export function useRunPick(next: { weekIdx: number; sessionIdx: number }) {
  const [touched, setTouched] = useState(false);
  const [weekIdx, setWeekIdx] = useState(next.weekIdx);
  const [sessionIdx, setSessionIdx] = useState(next.sessionIdx);
  useEffect(() => {
    if (touched) return;
    setWeekIdx(next.weekIdx);
    setSessionIdx(next.sessionIdx);
  }, [next.weekIdx, next.sessionIdx, touched]);
  const pick = useCallback((p: V3Start) => {
    setTouched(true);
    setSessionIdx(p.day);
    setWeekIdx(p.round);
  }, []);
  return {
    weekIdx,
    sessionIdx,
    /** The pick as the preview reads it, and its way back. */
    start: { day: sessionIdx, round: weekIdx },
    pick,
    pickWeek: (round: number) => pick({ day: sessionIdx, round }),
    pickSession: (day: number) => pick({ day, round: weekIdx }),
  };
}
